import React, { useEffect, useImperativeHandle,forwardRef, useState, useRef } from 'react';
import Table from 'react-bootstrap/Table';
import { AiOutlineEye } from 'react-icons/ai';
import Button from 'react-bootstrap/Button';
import {Form } from 'react-bootstrap';
import './EmailTemplateTable.css'; 
import EmailTempleteView from './EmailTempleteView';
import EmailTemplateEditor from './EmailTemplateEdit';
import editIcon from "../../Assets/edit.svg";
import { getEmailTemplateSetting, getEmailTemplateSettingById, updateEmailTemplateSetting } from '../../api/axios';
import {useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import CmsCircularProgress from '../../Components/Common/CircularProgress';
import CustomTable from '../../Components/Common/DataTable/DataTable';
const EmailTemplateTable = forwardRef(({ handleEdit, editRow, setEditRow, handleBack }, ref) => {
  const { partnerId, id: templateId } = useParams();
  const [emailTemplateData, setEmailTemplateData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSelectLoading, setIsSelectLoading] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const editorComponentRef = useRef(null);
  useEffect(() => {
    setIsLoading(true);
    if (!Number(partnerId) && !isLoading) {
      setIsLoading(false);
      return;
    }
    getAllPartnerByIdData();
  }, [partnerId]);

  useEffect(() => {
    if (templateId) {
      getTemplateById();
    }
  }, [templateId]);

  const getTemplateById = async () => {
    try {
      setIsLoading(true);
      const response = await getEmailTemplateSettingById(templateId);
      if (response?.data?.data) {
        setEditRow(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching template:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllPartnerByIdData = async () => {
    try {
      const response = await getEmailTemplateSetting(partnerId);
      const templateData = response.data.data;
      if (templateData && templateData.length > 0) {
        setEmailTemplateData(templateData);
      } else {
        setEmailTemplateData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    if (editRow) {
      await getAllPartnerByIdData();
    }
  };

  useImperativeHandle(ref, () => ({
    saveTemplate: () => {
      if (editorComponentRef.current) {
        return editorComponentRef.current.saveTemplate();
      }
    }
  }));

  const handleStatusChange = async (id, newStatus) => {
    try {
      setIsSelectLoading(id);
      const statusValue = newStatus === 'active' ? 1 : 0;
      await updateEmailTemplateSetting(id, { is_active: statusValue });
      await getAllPartnerByIdData();
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setIsSelectLoading(null);
    }
  };

  const handleView = (id) => {
    const row = emailTemplateData.find(item => item.id === id);
    setSelectedRow(row);
    setShowViewModal(true);
  };

  const handleCloseView = () => {
    setShowViewModal(false);
    setSelectedRow(null);
  };

  const toPascalCase = (str) => {
    if (!str) return '';
    return str
      .replace(/-/g, ' ')
      .replace(/\w\S*/g, (txt) =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      );
  };

  // const columns = [
  //   {
  //     label: 'Template Name',
  //   }
  // ];
  const columns= [
    {
      text: "Template Name",
      width: "270px"
    },
    {
      text: "Updated Date And Time",
      width: "200px"
    },
    {
      text: "Status",
      width: "50px"
    },
    {
      text: "Action",
      width: "50px"
    }
  ]

  const rows = [];

  // if(emailTemplateData && emailTemplateData.length > 0) {
  //  rows.push([
  //   emailTemplateData.name,
  //   emailTemplateData.updated_at,
  //   emailTemplateData.is_active,
  //  ]);
  // }

  if(Array.isArray(emailTemplateData) && emailTemplateData.length > 0) {
      // const item = emailTemplateData.map((item) => {
      // console.log("item ==>256666 ", item.name);
      //   return item.name, item.updated_at, item.is_active
      // });
      emailTemplateData.forEach((item) => {
      console.log("item ==> ", item);
        rows.push([
          toPascalCase(item.name),
          dayjs(item.updated_at).format('DD-MM-YY hh:mm A'),
          <> <Form.Check 
                      type="switch"
                      id={`status-switch-${item.id}`}
                      checked={item.is_active === 1}
                      onChange={(e) => handleStatusChange(item.id, e.target.checked ? 'active' : 'inactive')}
                      disabled={isSelectLoading === item.id}
                      className="custom-switch"
                      style={{ 
                        cursor: isSelectLoading === item.id ? 'not-allowed' : 'pointer',
                        marginRight: '8px',
                      }}
                    /></>,
                    <div className='gap-2 d-flex justify-content-center'>
                      <Button variant="contained" onClick={() => handleView(item.id)} className="w-auto m-0 p-0 border-0">
                        <AiOutlineEye size={17}/>
                      </Button>
                      <Button variant="contained" onClick={() => handleEdit(item)} className="edit-button w-auto m-0 p-0 border-0">
                        <img src={editIcon} alt="Edit" />
                      </Button>
                    </div>,]);
      });

  }

  return (
    <div className="table-wrapper">
      {isLoading ? (
        <CmsCircularProgress/>
      ) : templateId ? (
        <EmailTemplateEditor
          row={editRow}
          onBack={handleBack}
          onSave={handleSave}
          ref={editorComponentRef}
        />
      ) : (
       <>
        <CustomTable  columns={columns} rows={rows} />
       </>
      )}
      <EmailTempleteView
        show={showViewModal}
        onHide={handleCloseView}
        row={selectedRow}
      />
    </div>
  );
});

export default EmailTemplateTable;